import React from 'react';
import * as Actions from '../../../actions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
// import Switch from './Switch'
import { Slider, Switch } from 'antd';


class UIControls extends React.Component {
  render() {
    const { parameters: { renderBikes, rows, columns }, actions: { toggleRenderBikes, parameterRows, parameterColumns } } = this.props;
    return (
      <div className='dashboard-container'
        onMouseEnter={() => { this.props.actions.mouseOverDashboard(true) }}
        onMouseLeave={() => { this.props.actions.mouseOverDashboard(false) }}
      >
        Rows <Slider value={rows} onChange={parameterRows} max={5} />
        Columns <Slider value={columns} onChange={parameterColumns} max={5} />

        Render Bikes <Switch size="small" checked={renderBikes} onChange={toggleRenderBikes} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    parameters: state.parameters
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UIControls);



// WEBPACK FOOTER //
// ./src/components/Results/UIControls/index.js